import MenuSpy from "menuspy";

export function showMenuSpy() {
	document.addEventListener("DOMContentLoaded", function () {
		const header = document.getElementById("about-nav");

		if (header) {
			// Sử dụng Intersection Observer để theo dõi các section
			const observer = new IntersectionObserver(
				(entries) => {
					// Lọc ra các section đang visible
					const visibleSections = entries.filter((entry) => entry.isIntersecting);

					if (visibleSections.length > 0) {
						// Lấy section đầu tiên đang visible
						const firstVisibleSection = visibleSections[0];
						const id = firstVisibleSection.target.getAttribute("id");

						// Update active state in menu
						header.querySelectorAll("a").forEach((link) => {
							if (link.getAttribute("href") === `#${id}`) {
								link.classList.add("active");
							} else {
								link.classList.remove("active");
							}
						});

						// Update URL hash without scrolling
						history.replaceState(null, null, `#${id}`);
					}
				},
				{
					rootMargin: "-20% 0px -80% 0px",
					threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1], // Thêm nhiều threshold để tracking chính xác hơn
				}
			);

			// Observe tất cả các section
			document.querySelectorAll("section[id]").forEach((section) => {
				observer.observe(section);
			});

			// Smooth scroll với hash update
			const menuLinks = header.querySelectorAll("a");
			menuLinks.forEach((link) => {
				link.addEventListener("click", function (e) {
					e.preventDefault();
					const href = this.getAttribute("href");
					const target = document.querySelector(href);

					if (target) {
						// Update active state
						menuLinks.forEach((link) => link.classList.remove("active"));
						this.classList.add("active");

						// Scroll to target
						target.scrollIntoView({
							behavior: "smooth",
							block: "start",
						});

						// Update URL hash
						history.pushState(null, null, href);
					}
				});
			});

			// Check initial hash and set active state
			function setInitialActive() {
				if (window.location.hash) {
					const activeLink = header.querySelector(`a[href="${window.location.hash}"]`);
					if (activeLink) {
						menuLinks.forEach((link) => link.classList.remove("active"));
						activeLink.classList.add("active");

						const target = document.querySelector(window.location.hash);
						if (target) {
							target.scrollIntoView({
								behavior: "smooth",
								block: "start",
							});
						}
					}
				} else {
					// If no hash, activate first menu item
					const firstLink = header.querySelector("a");
					if (firstLink) {
						firstLink.classList.add("active");
					}
				}
			}

			// Set initial active state
			setInitialActive();

			// Handle scroll manually for edge cases
			let scrollTimeout;
			window.addEventListener("scroll", () => {
				if (scrollTimeout) {
					window.cancelAnimationFrame(scrollTimeout);
				}

				scrollTimeout = window.requestAnimationFrame(() => {
					const scrollPosition = window.scrollY;

					// Find the current visible section
					document.querySelectorAll("section[id]").forEach((section) => {
						const sectionTop = section.offsetTop;
						const sectionHeight = section.offsetHeight;

						if (
							scrollPosition >= sectionTop - 200 &&
							scrollPosition < sectionTop + sectionHeight - 200
						) {
							const id = section.getAttribute("id");
							header.querySelectorAll("a").forEach((link) => {
								if (link.getAttribute("href") === `#${id}`) {
									link.classList.add("active");
								} else {
									link.classList.remove("active");
								}
							});
						}
					});
				});
			});
		}
	});
}

showMenuSpy();
